// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as QueryString from 'query-string';
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { DatapointAllowedDimensionsResponseFromJSON, } from '../models';
/**
 * Get all datapoints allowed dimensions for given context
 * Get all datapoints allowed dimensions for given context
 */
export function getDatapointsAllowedDimensionsRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.context === null || requestParameters.context === undefined) {
        throw new runtime.RequiredError('context', 'Required parameter requestParameters.context was null or undefined when calling getDatapointsAllowedDimensions.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.context !== undefined) {
        queryParameters['context'] = requestParameters.context;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.isMyPosition !== undefined) {
        queryParameters['isMyPosition'] = requestParameters.isMyPosition;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints-allowed-dimensions` + queryString,
        meta,
        update: requestConfig.update || {
            DatapointsAllowedDimensions: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = DatapointAllowedDimensionsResponseFromJSON(body);
            if (body.id) {
                return { DatapointsAllowedDimensions: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { DatapointsAllowedDimensions: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `GetDatapointsAllowedDimensions-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get all datapoints allowed dimensions for given context
* Get all datapoints allowed dimensions for given context
*/
export function getDatapointsAllowedDimensions(requestParameters, requestConfig) {
    return getDatapointsAllowedDimensionsRaw(requestParameters, requestConfig);
}
